import { render, staticRenderFns } from "./PlaceManage.vue?vue&type=template&id=7b0d4221&"
import script from "./PlaceManage.vue?vue&type=script&lang=js&"
export * from "./PlaceManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports